import { type BdAvatar } from '@bizzdesign/shared/utils';
import { signalMethod, signalStore, withMethods } from '@ngrx/signals';
import { withChevron } from '@bizzdesign/ui-components';

export const AvatarGroupMenuComponentStore = signalStore(
  withChevron(),
  withMethods((store) => {
    const togglePopover = signalMethod<BdAvatar[]>((avatars) => {
      if (avatars.length === 0) {
        store.setIsPopoverOpened(false);
      }
    });

    return { togglePopover };
  }),
);

export type AvatarGroupMenuComponentStore = InstanceType<
  typeof AvatarGroupMenuComponentStore
>;
